/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { createContext, useContext, type ReactNode } from "react";

const Context = createContext<{
  webApi?: boolean;
  dataProvider?: "osm";
  forceLightScheme?: boolean;
  domain: "yandex.ru" | "yandex.com" | "yango.com";
}>({ domain: "yandex.ru" });

export const MapOptions = ({
  value,
  children,
}: {
  value: {
    webApi?: boolean;
    dataProvider?: "osm";
    forceLightScheme?: boolean;
    domain: "yandex.ru" | "yandex.com" | "yango.com";
  };
  children: ReactNode;
}) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useMapOptions = () => {
  const mapOptions = useContext(Context);

  return mapOptions;
};
